import { OrderOperationEntity } from 'api/types/entity/account/order';
import { renderDate, renderDateTime } from 'helpers/tableRenders';
import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { renderExecutionPlace } from './renders/executionPlace';

interface GetColumnsArgs {
  brokerTimezoneOffset: number;
}
const getColumns = (
  t: TFunc,
  { brokerTimezoneOffset }: GetColumnsArgs
): TableColumn<OrderOperationEntity>[] => [
  {
    field: 'executedAt',
    title: t('account.order.sections.operationsSection.columns.executedAt'),
    renderCell: (item, field) =>
      renderDateTime(item, field, brokerTimezoneOffset),
  },
  {
    field: 'settlementDate',
    title: t('account.order.sections.operationsSection.columns.settlementDate'),
    renderCell: (item, field) => renderDate(item, field, brokerTimezoneOffset),
  },
  {
    field: 'isin',
    title: t('account.order.sections.operationsSection.columns.isin'),
  },
  {
    field: 'quantity',
    title: t('account.order.sections.operationsSection.columns.quantity'),
  },
  {
    field: 'netUnitPrice',
    title: t('account.order.sections.operationsSection.columns.netUnitPrice'),
  },
  {
    field: 'volume',
    title: t('account.order.sections.operationsSection.columns.volume'),
  },
  {
    field: 'currency',
    title: t('account.order.sections.operationsSection.columns.currency'),
  },
  {
    field: 'executionPlace',
    title: t('account.order.sections.operationsSection.columns.executionPlace'),
    renderCell: (item) => renderExecutionPlace(item),
  },
];

export const useMobileColumns = ({ brokerTimezoneOffset }: GetColumnsArgs) => {
  const { t } = useTranslation();
  const columns = getColumns(t, { brokerTimezoneOffset });

  return columns;
};
